import { useEffect, useState } from 'react'
import { CUSTOMER_PATH, getPageCustomers } from '../../api/customerApi';
import { useApiProgress } from '../../hooks/ApiProgress';
import useFirstRender from '../../hooks/FirstRender';
import Textarea from '../../components/Textarea';
import { formatNumber, onChange } from '../../utils/functions';
import Input from '../../components/Input';
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi';
import { addOrder } from '../../api/orderApi';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { toast } from 'react-toastify';
import { VALIDATION_MESSAGE } from '../../utils/constants';
import Button from '../../components/Button';
import CustomerPicker from '../../components/customer/CustomerPicker';
import ProductPicker from '../../components/product/ProductPicker';
import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import ProductLabel from '../../components/product/ProductLabel';

const OrderAddPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const isFirstRender = useFirstRender()
    const [customerPage, setCustomerPage] = useState({
        content: []
    });

    const [productPage, setProductPage] = useState({
        content: []
    });

    const [customerQuery, setCustomerQuery] = useState('')
    const [productQuery, setProductQuery] = useState('')
    const [searchTimerCustomer, setSearchTimerCustomer] = useState();
    const [searchTimerProduct, setSearchTimerProduct] = useState();
    const pendingApiCallCustomer = useApiProgress('get', `${CUSTOMER_PATH}/page`, false)
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)

    const [customer, setCustomer] = useState()
    const [errors, setErrors] = useState({})
    const [order, setOrder] = useState({
        orderDate: "",
        vat: "",
        invoiceNumber: "",
        description: ""
    })
    const [orderDetails, setOrderDetails] = useState([])
    const [detail, setDetail] = useState({
        product: null,
        quantity: "",
        unitPrice: ""
    })

    const searchingCustomer = async (params) => {
        if (searchTimerCustomer) clearTimeout(searchTimerCustomer);
        let timer = setTimeout(() => {
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(res.data)
                })
        }, 500);
        setSearchTimerCustomer(timer);
    }

    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }

    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }

    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const onClickLoadMoreCustomer = () => {
        if (!customerPage.last) {
            loadCustomers({ search: customerQuery, lastId: customerPage.content[customerPage.content.length - 1]?.id })
        }
    }

    const loadCustomers = (params) => {
        !pendingApiCallCustomer &&
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])

    useEffect(() => {
        !isFirstRender && searchingCustomer({ search: customerQuery })
    }, [customerQuery])

    useEffect(() => {
        loadCustomers({ size: 20 })
        loadProducts({ size: 20 })
    }, [])

    const onClickAddDetail = () => {
        const { product, quantity, unitPrice } = detail
        if (!product || !quantity || !unitPrice) {
            toast.error(VALIDATION_MESSAGE)
            return
        }
        setOrderDetails(prevState => ([...prevState, detail]))
        setErrors(prev => ({ ...prev, details: undefined }))
    }

    const onSubmit = () => {
        const detailsBody = orderDetails.map(detail => {
            return {
                productId: detail.product?.id,
                quantity: detail.quantity,
                unitPrice: detail.unitPrice
            }
        })
        const orderBody = {
            customerId: customer?.id,
            orderDate: order.orderDate,
            vat: order.vat,
            invoiceNumber: order.invoiceNumber,
            description: order.description,
            details: detailsBody,
            parity: order.parity
        }
        addOrder(orderBody)
            .then(res => {
                toast.success('Sipariş kaydedildi')
                closeTab()
            }).catch(err => {
                setErrors(err.response.data.validationErrors)
                toast.error(VALIDATION_MESSAGE)
            })
    }

    const onClickRemoveDetail = (index) => {
        setOrderDetails(prevState => (prevState.filter((p, i) => i !== index)))
    }

    const onClickEditDetail = (detail, index) => {
        setDetail(detail)
        setOrderDetails(prevState => (prevState.filter((p, i) => i !== index)))
    }

    return (
        <div>
            <div className='mb-5'>
                <label className='text-xl'>Yeni Sipariş</label>
            </div>
            <div className='grid grid-cols-12 gap-x-3 mb-10'>
                <CustomerPicker
                    label='Müşteri'
                    pendingApiCall={pendingApiCallCustomer}
                    state={customer}
                    setState={(value) => setCustomer(value)}
                    query={customerQuery}
                    setQuery={setCustomerQuery}
                    error={errors.customerId}
                    page={customerPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, customerId: undefined }))}
                    onClickClear={() => setCustomer()}
                    onClickLoadMore={() => onClickLoadMoreCustomer()}
                />
                <div className='col-span-2'>
                    <Input
                        name='orderDate'
                        label='Sipariş Tarihi'
                        type='date'
                        value={order.orderDate}
                        error={errors?.orderDate}
                        onChange={e => onChange(e, setOrder, setErrors)}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='vat'
                        label='Vergi Oranı (%)'
                        type='number'
                        placeholder='Vergi oranı...'
                        value={order.vat}
                        error={errors?.vat}
                        onChange={e => onChange(e, setOrder, setErrors)}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='invoiceNumber'
                        label='Fatura Numarası'
                        type='text'
                        placeholder='Fatura numarası...'
                        value={order.invoiceNumber}
                        error={errors?.invoiceNumber}
                        onChange={e => onChange(e, setOrder, setErrors)}
                    />
                </div>
                <div className='col-span-1'>
                    <Input
                        name='parity'
                        label='Parite'
                        type='number'
                        placeholder='Parite...'
                        value={order.parity}
                        error={errors?.parity}
                        onChange={e => onChange(e, setOrder, setErrors)}
                    />
                </div>
                <div className='col-span-2'>
                    <Textarea
                        name='description'
                        label='Açıklama'
                        type='text'
                        placeholder='Açıklama girin...'
                        value={order.description}
                        error={errors?.description}
                        onChange={e => onChange(e, setOrder, setErrors)}
                    />
                </div>
            </div>
            <table className='w-full text-left text-zinc-900'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>#</th>
                        <th className='p-2 w-4/12'>Ürün</th>
                        <th className='p-2 w-2/12'>Metre</th>
                        <th className='p-2 w-2/12'>{`Birim Fiyat ${customer ? `(${customer.currency}/m)` : ""}`} </th>
                        <th className='p-2 w-2/12'>Toplam {customer ? `(${customer.currency})` : ""}</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        orderDetails.map((detail, index) => (
                            <tr className='border-b items-center sticky top-20 bg-zinc-50' key={index}>
                                <td className='py-2'>{index + 1} </td>
                                <td>{detail.product && <ProductLabel state={detail.product} />} </td>
                                <td>{formatNumber(detail.quantity)} m</td>
                                <td>{formatNumber(detail.unitPrice)}</td>
                                <td>{formatNumber((detail.unitPrice * detail.quantity).toFixed(2))} </td>
                                <td lassName='p-2 items-center'  >
                                    <div className='flex gap-x-3'>
                                        <MdEdit onClick={() => onClickEditDetail(detail, index)} />
                                        <FaMinus onClick={() => onClickRemoveDetail(index)} />
                                    </div>

                                </td>
                            </tr>
                        ))
                    }
                    <tr className='bg-zinc-200'>
                        <td className='py-2'>Toplam</td>
                        <td></td>
                        <td className='py-2'>{formatNumber(orderDetails.reduce((a, c) => a + Number(c.quantity), 0))} m</td>
                        <td></td>
                        <td className='py-2'>{formatNumber((orderDetails.reduce((a, c) => a + c.unitPrice * c.quantity, 0)).toFixed(2))} {customer ? `${customer.currency}` : ""}</td>
                        <td></td>
                    </tr>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td></td>
                        <td>
                            {/* PRODUCT PICKER */}
                            <ProductPicker
                                //label='Ürün'
                                pendingApiCall={pendingApiCallProduct}
                                state={detail.product}
                                setState={(value) => setDetail(prevState => ({ ...prevState, product: value }))}
                                query={productQuery}
                                setQuery={setProductQuery}
                                error={errors.productId}
                                page={productPage}
                                setErrors={() => setErrors(prevState => ({ ...prevState, productId: undefined }))}
                                //onClickClear={() => setDetail(prevState => ({ ...prevState, product: undefined }))}
                                onClickLoadMore={() => onClickLoadMoreProduct()}
                            />
                        </td>
                        <td>
                            <Input
                                type='number'
                                placeholder='Metre girin...'
                                value={detail.quantity}
                                name='quantity'
                                onChange={e => onChange(e, setDetail)}
                            />
                        </td>
                        <td>
                            <Input
                                type='number'
                                placeholder='Birim fiyat girin...'
                                value={detail.unitPrice}
                                name='unitPrice'
                                onChange={e => onChange(e, setDetail)}
                            />
                        </td>
                        <td></td>
                        <td>
                            <span onClick={onClickAddDetail}><FaPlus /></span>
                        </td>
                    </tr>
                </tbody>
            </table>
            {errors.details && <label className='text-xs text-red-700 block mb-5'>{errors.details} </label>}
            <div className='flex justify-center'>
                <Button
                    text='Kaydet'
                    variant='green'
                    onClick={onSubmit}
                />
            </div>
        </div>
    )
}

export default OrderAddPage